import axios from '@/lib/axios';
import type { RegistrationParams } from '../../flatRates/types';

const createEditInfo = (data: RegistrationParams) => {
  return axios.post('/customer/edit_info', data);
}

export default createEditInfo;